import React from 'react';
import { Route, Routes } from 'react-router-dom';
import SolarysHome from '../solarys/Home';

function Router() {
  return (
    <Routes>
      <Route exact path="/solarys/home" element={<SolarysHome />} />
    </Routes>
  );
}

export default Router;
